import styled from 'styled-components';
import { typography } from 'styled-system';
import lobbyLabelBg from './assets/bg-content.png';

export const SlotStyle = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid rgba(40, 193, 246, 0);
  transition: all .2s;
`;

export const CarouselSlot = styled.a`
  width: 100%;
  height: 100%;
  display: block;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const CarouselSlotLabel = styled.p`
  color: #fff;
  width: 400px;
  font-size: 20px;
  text-align: left;
  margin: 0;
  position: absolute;
  float: left;
  padding-left: 70px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  font-family: 'DINNextLTPro';
  font-weight: 400;
`;

export const CarouselSlotDisclaimer = styled.span`
  font-size: 10px;
  text-align: right;
  position: absolute;
  bottom: 10px;
  right: 20px;
  z-index: 10;
  color: #fff;
`;

export const SlotMediaContainer = styled.div`

`;

export const SlotHoverContainer = styled.div`
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  transition: all .4s;
  opacity: 0;
`;

export const SlotDisclaimer = styled.div`
  display: none;
`;

export const SlotLabel = styled.div`
  position: absolute;
  padding: 15px 10px;
  width: 93%;
  float: left;
  display: block;
  text-align: left;
  font-size: 18px;
  color: #fff;
  transition: all .2s;
  opacity: .7;
  font-family: 'DINNextLTPro';
  font-weight: 400;
  transition: all .2s;
  ${SlotDisclaimer} {
    position: absolute;
    top: 0px;
    font-size: 10px;
    right: 0px;
    opacity: .7;
    display: block;
  }
`;



export const SkyscraperLabel = styled.div`
  position: absolute;
  bottom: 10px;
  z-index: 10;
  margin: 10px;
  font-size: 14px;
  color: #fff;
  text-align: left;
  opacity: .7;
  transition: all .2s;
  ${typography}
  font-family: 'DINNextLTPro';
  line-height: 1.3;
  font-weight: 400;
`;



export const LobbyLabel = styled.div`
  position: absolute;
  bottom: 0px;
  z-index: 10;
  margin: 10px;
  font-size: 16px;
  color: #fff;
  text-align: left;
  opacity: 1;
  transition: all .2s;
  ${typography}
  font-family: 'DINNextLTPro';
  line-height: 1.3;
  font-weight: 400;

  /* text-align: center; */
  /* position: static; */
  text-decoration: none;
  color: white;
  margin: 0;
  padding: 50px 10px 15px;
  background: url(${lobbyLabelBg}) repeat-x left top;
  background-size: auto;
  background-size: 1px 100%;
  ${SlotDisclaimer} {
    position: absolute;
    bottom: 0px;
    font-size: 10px;
    right: 10px;
    opacity: .7;
    display: block;
  }
`;

export const SlotButton = styled.button`
  width: 100%;
  // height: 100%;
  cursor: pointer;
  background: none;
  padding: 0;
  border: none;
  margin: 0;
  :hover ${SlotStyle} {
    transform: translate(0,-1.5%);
    border: 3px solid ${props => props.theme.slotHoverOutlineColor};
  }
  :hover ${SlotLabel} {
    opacity: 1;
    transform: translate(0,-4%);
  }

  :hover ${SkyscraperLabel} {
    opacity: 1;
  }

  :hover ${SlotHoverContainer} {
    opacity: 1;
  }

  &.lang-fr ${SkyscraperLabel} {
    font-size: 13px;
    line-height: 1.1;
  }
`;
